var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31142 6.61948C3.31142 6.39999 3.39861 6.18949 3.55382 6.03429C3.70902 5.87908 3.91952 5.79189 4.13901 5.79189H19.0356V4.9643C19.0356 4.74482 18.9484 4.53432 18.7932 4.37911C18.638 4.22391 18.4275 4.13672 18.208 4.13672H2.48384C2.26435 4.13672 2.05385 4.22391 1.89864 4.37911C1.74344 4.53432 1.65625 4.74482 1.65625 4.9643V15.7229C1.65625 15.9424 1.74344 16.1529 1.89864 16.3081C2.05385 16.4633 2.26435 16.5505 2.48384 16.5505H3.31142V6.61948Z",
    fill: "#CD0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79243 7.44922H21.5166C21.7361 7.44922 21.9466 7.53641 22.1018 7.69161C22.257 7.84682 22.3442 8.05732 22.3442 8.2768V19.0354C22.3442 19.2549 22.257 19.4654 22.1018 19.6206C21.9466 19.7758 21.7361 19.863 21.5166 19.863H5.79243C5.57294 19.863 5.36244 19.7758 5.20724 19.6206C5.05204 19.4654 4.96484 19.2549 4.96484 19.0354V8.2768C4.96484 8.05732 5.05204 7.84682 5.20724 7.69161C5.36244 7.53641 5.57294 7.44922 5.79243 7.44922Z",
    fill: "#CD0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.e6e360123f7818d00651c2ca00d5ad9d.svg";
export { ForwardRef as ReactComponent };